import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ArtikelGroupServiceConfig = {
  name: "ArtikelGroup",
  annotations: []
} as ServiceConfig;